import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {router} from '../main'
import { penthouses } from '../content/penthouses'
import { filterPenthouses } from '../mixins/filter'
import { bubbleSort } from '../mixins/sort'

Vue.use(Vuex)


export const store = new Vuex.Store({
  state: {
    penthousesList: {
      isLoading: null as Boolean,
      list: [],
      error: null as Boolean
    },
    penthouseDetailed: {
      isLoading: null as Boolean,
      content: null as Object,
      error: null as Boolean,
    },
    windowWidth: null as Number,
    filtersActive: null as Object,
    filterIsOpened: false as Boolean,
    sortParam: null as String,
    sortFromSmall: false as Boolean,
    statusesAndPrices: {
      loading: null as Boolean,
      content: [],
      error: null as Object
    }
  },
  mutations: {
    openFilter(state){
      state.filterIsOpened = !state.filterIsOpened
    },
    setWindowWidth(state, payload) {
      state.windowWidth = payload
    },
    penthousesLoading(state) {
      state.penthousesList.isLoading = true;
      state.penthousesList.error = false;
    },
    penthousesLoaded(state, payload) {
      state.penthousesList.isLoading = false;
      state.penthousesList.error = false;
      state.penthousesList.list = payload;
    },
    penthousesLoadingError(state) {
      state.penthousesList.isLoading = false;
      state.penthousesList.error = true;
    },
    penthouseDetailedLoading(state) {
      state.penthouseDetailed.isLoading = true;
      state.penthouseDetailed.error = false;
    },
    penthouseDetailedLoaded(state, payload) {
      state.penthouseDetailed.isLoading = false;
      state.penthouseDetailed.error = false;
      state.penthouseDetailed.content = payload;
    },
    penthouseDetailedLoadingError(state) {
      state.penthouseDetailed.isLoading = false;
      state.penthouseDetailed.error = true;
    },
    updateFilters(state, payload) {
      state.filtersActive = payload
    },
    updateSort(state, payload) {
      state.sortParam = payload.param;
      state.sortFromSmall = payload.sortFromSmall;
    },
    statusesAndPricesLoading(state) {
      state.statusesAndPrices.loading = true;
      state.statusesAndPrices.error = null;
      state.statusesAndPrices.content = null;
    },
    statusesAndPricesLoaded(state, payload) {
      state.statusesAndPrices.loading = false;
      state.statusesAndPrices.error = null;
      state.statusesAndPrices.content = payload;
    },
    statusesAndPricesLoadingError(state, payload) {
      state.statusesAndPrices.loading = false;
      state.statusesAndPrices.error = payload;
      state.statusesAndPrices.content = null;
    }
  },
  getters: {
    penthousesFilteredAndSorted(state) {
      if (state.penthousesList.list.length > 0){
        return bubbleSort(filterPenthouses(state.penthousesList.list, state), state.sortParam, state.sortFromSmall)
      } 
    },
  },
  actions: {
    updateSort({commit}, payload) {
      commit('updateSort', payload);
    },
    updateFilters({commit},payload) {
      commit('updateFilters', payload)
    },
    async getStatusesAndPrices({commit}) {
      commit('statusesAndPricesLoading');
      return axios.get(`/api/penthouses.php`)
        .then(response => {
          commit('statusesAndPricesLoaded', response.data);
          return response.data
        })
        .catch(err => {
          console.log(`Error loading statuses and prices: ${err}`)
          commit('statusesAndProccessLoadingError', err)
        })
    },
    async getPenthousesList({commit}) {
      commit('penthousesLoading');
      return new Promise((resolve) => {
        resolve(penthouses)
      }).then((data) => {
        commit('penthousesLoaded', data)
      }).catch((error) => {
        commit('penthousesLoadingError')
        console.log(`Error loading list of penthouses: ${error}`)
      })
    },
    async getPenthouseDetailed({commit}, payload) {
      commit('penthouseDetailedLoading');
      return new Promise((resolve) => {
        resolve(penthouses.find(item => item.pentNumber === payload));

      }).then(data => {
        commit('penthouseDetailedLoaded', data);
      }).catch(error => {
        commit('penthouseDetailedLoadingError');
        console.log(`Error loading detailed page of penthouse: ${error}`)
      })
    }
  }
})